import React from 'react'
import LandingJoinNow from './section/LandingJoinNow'
import LandingShare from './section/LandingShare'
import LandingBanner from './section/LandingBanner'
import LandingShareCarosel from './section/LandingShareCarosel'
import LandingIconBanner from './section/LandingIconBanner'
import CourseTimeline_FullTime from "../CourseDetailsPage/_content/vocational_training/full_time/component/CourseTimeline_FullTime";
import { Container, Stack } from "@mui/material";
import { alpha } from '@mui/system';

const LandingPage = () => {
  return (
    <Stack sx={{ width: 1, overflowX: "hidden" }}>
      <LandingBanner />
      <LandingIconBanner />
      <Stack
        component="section"
        sx={{
          width: 1,
          py: { xs: 8, md: 16 },
          bgcolor: theme => alpha(theme.palette.background.default, 0.9),
        }}
      >
        <Container maxWidth="xl" sx={{ px: { xs: 3, md: 5 } }}>
          <CourseTimeline_FullTime />
        </Container>
      </Stack>
      <LandingShare />
      <LandingShareCarosel />
      <LandingJoinNow />
    </Stack>
  )
}
export default LandingPage

